import {
  PreschoolCriterionType,
  PreschoolEvaluationOption,
} from '@/types/components';
import type { PreschoolCriterion } from '@/types/preschool';

const evaluationOptions: Record<string, PreschoolEvaluationOption> = {
  yes: PreschoolEvaluationOption.Yes,
  no: PreschoolEvaluationOption.No,
  partially: PreschoolEvaluationOption.Partially,
};

export const getEvaluationOption = (
  criterion: PreschoolCriterion,
): PreschoolEvaluationOption | undefined => {
  const { type, evaluation } = criterion;

  if (type !== PreschoolCriterionType.MultiOption || !evaluation) {
    return undefined;
  }

  return evaluationOptions[evaluation.toLowerCase()];
};

export const getEvaluationText = (criterion: PreschoolCriterion): string => {
  const { evaluation, optionValues, boolOptionNames } = criterion;

  if (!evaluation) {
    return '';
  }

  const optionIndex = optionValues.indexOf(evaluation);

  return boolOptionNames[optionIndex] ?? evaluation;
};
